import React, { useState } from 'react'



const EthicsCode = ({ title = "", description = "", items = [], mainContaierClass = "", titleClass = "", isHideNumber = true }) => {

    return (
        <section className={`w-full bg-gradient-radial py-12 lg:py-24 ${mainContaierClass}`} id="membership-code-of-ethics">
            <div className="container mx-auto px-4 lg:px-15">
                <div className='w-full flex flex-col justify-between items-center'>

                    <h2 className={`text-2xl sm:text-3xl lg:text-5xl font-bold font-urbanist text-white text-center mb-8 lg:mb-12 ${titleClass || ""}`}>
                        {title}
                    </h2>
                    {
                        !!description &&
                        <p className='mt-2 text-md text-center text-white mb-12 px-4 lg:px-48 font-inter'>
                            {description}
                        </p>

                    }

                    {/* Grid for the Ethics Principles */}
                    <div className="flex flex-row flex-wrap flex-auto justify-between items-start max-w-6xl w-full md:w-[82%] flex-grow gap-6 font-urbanist">
                        {items.map((principle, index) => {
                            const radiusClass = index % 2 === 1 ? 'rounded-tr-md' : 'rounded-tl-md';
                            return (
                                <ItemCard
                                    index={index}
                                    isHideNumber={isHideNumber}
                                    key={principle.id}
                                    radiusClass={radiusClass}
                                    {...principle}

                                />
                            )
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
};

const ItemCard = ({ index = 0, radiusClass = "", isHideNumber = false, ...principle }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleItem = () => {
        setIsOpen(!isOpen);
    };

    return (
        <div
            className={`w-full md:w-[48%] flex flex-col items-center bg-gradient-radial px-3 md:px-5 py-3 md:py-3 rounded-[1.7rem] ${radiusClass} border border-white ${!!principle.content && (isOpen ? 'p-6' : 'p-4')} ${!principle.content && 'p-4'} transition-all duration-300 ease-in-out`}
        >
            <div
                className={`w-full flex items-center justify-between cursor-pointer transition-colors duration-200 rounded-md -mx-2 px-2 ${principle.content && isOpen ? 'mb-1' : ''}`}
                onClick={() => (!!principle.content && toggleItem(principle.id))}
            >
                <div className="flex items-center text-left">
                    {
                        isHideNumber &&
                        <span className="text-md md:text-lg font-bold text-gray-300 mr-2 md:mr-4">
                            {(index + 1)}.
                        </span>
                    }
                    <h2 className="text-sm md:text-lg font-semibold text-gray-50 m-0">
                        {principle.title}
                    </h2>
                </div>
                <div className='w-5 h-5'>
                    <img
                        className={`w-5 h-5 transform transition-transform duration-300 ${isOpen ? '' : 'rotate-180'}`}
                        src='/assets/services/1/angle-down.png'
                        alt='angle-down'
                    />
                </div>
            </div>

            {/* Expandable Content */}
            {
                principle.content && (
                    <div
                        className={`
                                overflow-hidden transition-all duration-300 ease-in-out
                                ${isOpen ? 'max-h-96 opacity-100 pt-3' : 'max-h-0 opacity-0'}
                                ${isOpen ? 'border-t border-gray-500 border-dashed' : ''} 
                                ${isOpen ? 'mt-1' : 'mt-0'}
                                ${typeof principle?.content === 'object' ? 'space-y-3' : ''}
                                `}
                    >
                        {typeof principle?.content === 'object' ? (
                            principle.content.map((point, idx) => (
                                <p key={idx} className="text-gray-300 leading-relaxed text-sm list-disc list-inside">
                                    {point}
                                </p>
                            ))
                        ) :
                            (
                                <p className="text-gray-300 leading-relaxed text-sm">
                                    {principle.content}
                                </p>
                            )}
                    </div>
                )}
        </div>
    )
}

export default EthicsCode;